// extracted by mini-css-extract-plugin
export default {"loading":"index_loading__vYJHx","absolute":"index_absolute__4n9N6"};